// Núcleo CSV del backoffice. Una sola implementación de escapado (RFC 4180),
// reutilizada por los builders de dominio (usuarios, deployments). Emite BOM
// UTF-8 para que Excel abra los acentos correctamente.

const BOM = '﻿';

/** Entrecomilla la celda si contiene coma, comilla doble o salto de línea. */
function escapeCell(value: string): string {
  if (/[",\r\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

/**
 * Ensambla un CSV RFC 4180 con cabecera + filas.
 *
 * @param headers nombres de columna (primera línea)
 * @param rows filas ya convertidas a string (celda vacía = '')
 * @returns texto CSV con BOM UTF-8 y separador de línea CRLF
 */
export function toCsv(headers: string[], rows: string[][]): string {
  const lines = [headers, ...rows].map((cells) => cells.map(escapeCell).join(','));
  return BOM + lines.join('\r\n');
}

/**
 * Dispara la descarga de un fichero CSV en el navegador (Blob + <a download>).
 */
export function downloadCsv(filename: string, content: string): void {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** Nombre de fichero `<prefix>-YYYY-MM-DD.csv` (fecha local, hoy por defecto). */
export function csvFilename(prefix: string, date: Date = new Date()): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${prefix}-${y}-${m}-${d}.csv`;
}
